/**
 * Determines the sort direction that should be used on filter change.
 * In case a filter whose selectedMethod is active, then the direction should
 * be inverted, else we simply start off by sorting ascending when chaning the
 * sort method.
 */
function getNextSortDirection(state, selectedMethod) {
  return state.sortedBy === selectedMethod ? state.direction === "asc" ? "desc" : "asc" : "asc";
}

export { getNextSortDirection };
//# sourceMappingURL=util.get-next-sort-direction.js.map
